import { default as indexWg3fJAjWbAMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/alerts/index.vue?macro=true";
import { default as indexgYC7WhPitpMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/dashboards/index.vue?macro=true";
import { default as indexuSTH0ffC8VMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/events/index.vue?macro=true";
import { default as indexqf0c8pCCnkMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/groups/index.vue?macro=true";
import { default as index4BXq47i9uBMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/index.vue?macro=true";
import { default as newPiceO9gdPfMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/judges/new.vue?macro=true";
import { default as judgesdIGZ2uBj5FMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/judges.vue?macro=true";
import { default as indexVmvkJ6zUkSMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/notebooks/index.vue?macro=true";
import { default as indexaGBa1HPAcSMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/people/index.vue?macro=true";
import { default as indexl5Nj35e36VMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/queries/index.vue?macro=true";
import { default as indexE41r0EmiabMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/index.vue?macro=true";
import { default as indexz1RsxxS6DyMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/index.vue?macro=true";
import { default as membersFXe2PPThV7Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/members.vue?macro=true";
import { default as newXY1V3A02f4Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/tokens/new.vue?macro=true";
import { default as tokenseaFS0kdBrmMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/tokens.vue?macro=true";
import { default as _91project_slug_93tCaISlcvndMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug].vue?macro=true";
import { default as newLRz3n55dKGMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/api-keys/new.vue?macro=true";
import { default as api_45keys2bFiMDzZLzMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/api-keys.vue?macro=true";
import { default as indexnLLz3WrwhQMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/index.vue?macro=true";
import { default as membersbPDtdUoKRFMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/members.vue?macro=true";
import { default as settingsEVsqfMF4d7Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings.vue?macro=true";
import { default as callbackKqG0v0bsfqMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/auth/github/callback.vue?macro=true";
import { default as callbackl5kBtgHB0bMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/auth/google/callback.vue?macro=true";
import { default as _91slug_93D45HSj1oLZMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/blog/[slug].vue?macro=true";
import { default as indexiL8Fqbk0s0Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/blog/index.vue?macro=true";
import { default as blogWgwAorlts8Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/blog.vue?macro=true";
import { default as _91_46_46_46slug_93tWbU8RVrNGMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/docs/[...slug].vue?macro=true";
import { default as indexLYEgydRujxMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/docs/index.vue?macro=true";
import { default as docssJjFPpIQZYMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/docs.vue?macro=true";
import { default as errorus4AeYuv3sMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/error.vue?macro=true";
import { default as forgot_45passwordn87s9yJxuDMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/forgot-password.vue?macro=true";
import { default as indexHa2dx0aLATMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/index.vue?macro=true";
import { default as loginc15LDbCheaMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/login.vue?macro=true";
import { default as create_45projectYUWQzhZCdIMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/create-project.vue?macro=true";
import { default as create_45workspaceGbFkMFHMV4Meta } from "/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/create-workspace.vue?macro=true";
import { default as index6131icW2hFMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/index.vue?macro=true";
import { default as verify_45emailADAnYrTr8EMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/verify-email.vue?macro=true";
import { default as pricing3N60cUW1ZRMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/pricing.vue?macro=true";
import { default as request_45access0K4dd8XEjfMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/request-access.vue?macro=true";
import { default as reset_45passwordo8195A1eYNMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/reset-password.vue?macro=true";
import { default as signuph1fFjX81fzMeta } from "/home/boristane/boristane/zirp/apps/web/app/pages/signup.vue?macro=true";
export default [
  {
    name: "workspace_slug-project_slug-alerts",
    path: "/:workspace_slug()/:project_slug()/alerts",
    meta: indexWg3fJAjWbAMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/alerts/index.vue")
  },
  {
    name: "workspace_slug-project_slug-dashboards",
    path: "/:workspace_slug()/:project_slug()/dashboards",
    meta: indexgYC7WhPitpMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/dashboards/index.vue")
  },
  {
    name: "workspace_slug-project_slug-events",
    path: "/:workspace_slug()/:project_slug()/events",
    meta: indexuSTH0ffC8VMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/events/index.vue")
  },
  {
    name: "workspace_slug-project_slug-groups",
    path: "/:workspace_slug()/:project_slug()/groups",
    meta: indexqf0c8pCCnkMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/groups/index.vue")
  },
  {
    name: "workspace_slug-project_slug",
    path: "/:workspace_slug()/:project_slug()",
    meta: index4BXq47i9uBMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/index.vue")
  },
  {
    name: "workspace_slug-project_slug-judges",
    path: "/:workspace_slug()/:project_slug()/judges",
    meta: judgesdIGZ2uBj5FMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/judges.vue"),
    children: [
  {
    name: "workspace_slug-project_slug-judges-new",
    path: "new",
    meta: newPiceO9gdPfMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/judges/new.vue")
  }
]
  },
  {
    name: "workspace_slug-project_slug-notebooks",
    path: "/:workspace_slug()/:project_slug()/notebooks",
    meta: indexVmvkJ6zUkSMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/notebooks/index.vue")
  },
  {
    name: "workspace_slug-project_slug-people",
    path: "/:workspace_slug()/:project_slug()/people",
    meta: indexaGBa1HPAcSMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/people/index.vue")
  },
  {
    name: "workspace_slug-project_slug-queries",
    path: "/:workspace_slug()/:project_slug()/queries",
    meta: indexl5Nj35e36VMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/[project_slug]/queries/index.vue")
  },
  {
    name: "workspace_slug",
    path: "/:workspace_slug()",
    meta: indexE41r0EmiabMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/index.vue")
  },
  {
    name: settingsEVsqfMF4d7Meta?.name,
    path: "/:workspace_slug()/settings",
    meta: settingsEVsqfMF4d7Meta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings.vue"),
    children: [
  {
    name: _91project_slug_93tCaISlcvndMeta?.name,
    path: ":project_slug()",
    meta: _91project_slug_93tCaISlcvndMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug].vue"),
    children: [
  {
    name: "workspace_slug-settings-project_slug",
    path: "",
    meta: indexz1RsxxS6DyMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/index.vue")
  },
  {
    name: "workspace_slug-settings-project_slug-members",
    path: "members",
    meta: membersFXe2PPThV7Meta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/members.vue")
  },
  {
    name: "workspace_slug-settings-project_slug-tokens",
    path: "tokens",
    meta: tokenseaFS0kdBrmMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/tokens.vue"),
    children: [
  {
    name: "workspace_slug-settings-project_slug-tokens-new",
    path: "new",
    meta: newXY1V3A02f4Meta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/[project_slug]/tokens/new.vue")
  }
]
  }
]
  },
  {
    name: "workspace_slug-settings-api-keys",
    path: "api-keys",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/api-keys.vue"),
    children: [
  {
    name: "workspace_slug-settings-api-keys-new",
    path: "new",
    meta: newLRz3n55dKGMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/api-keys/new.vue")
  }
]
  },
  {
    name: "workspace_slug-settings",
    path: "",
    meta: indexnLLz3WrwhQMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/index.vue")
  },
  {
    name: "workspace_slug-settings-members",
    path: "members",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/[workspace_slug]/settings/members.vue")
  }
]
  },
  {
    name: "auth-github-callback",
    path: "/auth/github/callback",
    meta: callbackKqG0v0bsfqMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/auth/github/callback.vue")
  },
  {
    name: "auth-google-callback",
    path: "/auth/google/callback",
    meta: callbackl5kBtgHB0bMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/auth/google/callback.vue")
  },
  {
    name: blogWgwAorlts8Meta?.name,
    path: "/blog",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/blog.vue"),
    children: [
  {
    name: "blog-slug",
    path: ":slug()",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/blog/index.vue")
  }
]
  },
  {
    name: docssJjFPpIQZYMeta?.name,
    path: "/docs",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/docs.vue"),
    children: [
  {
    name: "docs-slug",
    path: ":slug(.*)*",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/docs/[...slug].vue")
  },
  {
    name: "docs",
    path: "",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/docs/index.vue")
  }
]
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/error.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordn87s9yJxuDMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/forgot-password.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginc15LDbCheaMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/login.vue")
  },
  {
    name: "onboarding-create-project",
    path: "/onboarding/create-project",
    meta: create_45projectYUWQzhZCdIMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/create-project.vue")
  },
  {
    name: "onboarding-create-workspace",
    path: "/onboarding/create-workspace",
    meta: create_45workspaceGbFkMFHMV4Meta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/create-workspace.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: index6131icW2hFMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/index.vue")
  },
  {
    name: "onboarding-verify-email",
    path: "/onboarding/verify-email",
    meta: verify_45emailADAnYrTr8EMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/onboarding/verify-email.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/pricing.vue")
  },
  {
    name: "request-access",
    path: "/request-access",
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/request-access.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordo8195A1eYNMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/reset-password.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signuph1fFjX81fzMeta || {},
    component: () => import("/home/boristane/boristane/zirp/apps/web/app/pages/signup.vue")
  }
]